export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.728 3.306c.908.003 1.815.006 2.721.006h.028l.027.001c1.451.08 2.713.468 3.623 1.28.935.834 1.366 1.997 1.366 3.33 0 1.628-.771 2.866-1.962 3.663.359.186.68.4.963.64 1.166.99 1.574 2.3 1.574 3.51 0 1.448-.527 2.71-1.565 3.595-1.019.867-2.424 1.28-4.031 1.28H6V3.3h1c.91 0 1.82.003 2.728.006zM8 18.61h4.472c1.284 0 2.178-.33 2.734-.803.536-.457.862-1.133.862-2.073 0-.753-.241-1.452-.867-1.982-.65-.55-1.85-1.037-4.005-1.037H8v5.895zm0-7.895h3.196l.49-.013c1.117-.06 2.05-.332 2.703-.758.702-.458 1.104-1.103 1.104-2.021 0-.886-.271-1.458-.698-1.838-.451-.402-1.208-.71-2.39-.775-.896 0-1.79-.002-2.683-.005L8 5.302v5.414z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};